import { RefreshCw, X } from "lucide-react";

import { useAppUpdate, type AppUpdateOptions } from "../lib/pwa-update";

/**
 * Avviso discreto di versione nuova. Compare in basso, sopra il resto,
 * e resta finche l'utente decide: aggiorna adesso oppure lo chiude.
 */
export function UpdateBanner(options: AppUpdateOptions = {}) {
  const { updateReady, applyUpdate, dismiss } = useAppUpdate(options);
  if (!updateReady) return null;

  return (
    <div className="update-banner" role="status" aria-live="polite">
      <RefreshCw size={18} aria-hidden="true" />
      <p>Nuova versione disponibile, tocca per aggiornare.</p>
      <button className="update-banner__action" type="button" onClick={applyUpdate}>Aggiorna ora</button>
      <button className="update-banner__close" type="button" onClick={dismiss} aria-label="Chiudi avviso"><X size={18} /></button>
    </div>
  );
}
